export { backgroundImage } from '@nubank/nuds-web/components/Image/Image';
export { imageShape } from '@nubank/nuds-web/components/Image/Image';
export { default } from '@nubank/nuds-web/components/Image/Image';
